import React, { Component } from 'react';

class ErrorBoundry extends Component {
	constructor(props) {
		super(props);
		this.state = { error: false };
	}

	static getDerivedStateFromError(error) {
		return {
			error: true,
		};
	}

	componentDidCatch(error, info) {}

	render() {
		if (this.state.error) {
			return (
				<div className="error-boundry">
					<h3>Something went wrong...!</h3>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundry;
